import React, { useState } from 'react';
import 'rsuite/dist/rsuite.min.css'; // Asegúrate de importar el CSS de RSuite
import { Table, Checkbox, CheckPicker, Panel } from 'rsuite';
import style from './TableBackoffice.module.css';
import { PaginationList } from '@commons/modules/Settings/PaginationList';
import { useRouter } from 'next/router';
import { ExAvatarTablePosAdmin } from '@commons/EXComponentsLibrary';

const { Column, HeaderCell, Cell } = Table;

const TableBackoffice = ({ data, columns, tableHeigth, loading, pagination, sortTable }) => {
    // next
    const router = useRouter();
    // state
    const [visibleKeys, setVisibleKeys] = useState(columns.map((c) => c.key));
    const [checkedKeys, setCheckedKeys] = useState([]);

    const allChecked = checkedKeys.length === data?.length;
    const indeterminate = checkedKeys.length > 0 && checkedKeys.length < data.length;

    const { total, activePage, limit, isLoading: paginationLoading, onChangePage, onChangeLimit, pages } = pagination;

    const { onSortColumn, sortType, sortColumn } = sortTable;

    // Marcar/desmarcar todos
    const handleCheckAll = (checked) => {
        setCheckedKeys(checked ? data.map((row) => row.id) : []);
    };

    // Marcar/desmarcar fila individual
    const handleCheck = (id, checked) => {
        setCheckedKeys((prev) => (checked ? [...prev, id] : prev.filter((key) => key !== id)));
    };

    return (
        <>
            <Panel style={{ background: '#fff' }}>
                <Table
                    data={data}
                    loading={loading}
                    rowKey="id"
                    height={tableHeigth}
                    style={{ borderRadius: '4px' }}
                    renderEmpty={() =>
                        router.pathname === '/disable-points-of-sale' && (
                            <div className={style['container-placeholder']}>
                                <img src="/assets/images/placeholder-table.svg" />
                                <p className={style['placeholder']}>No hay puntos de venta deshabilitados</p>
                                <p className={style['sub-placeholder']}>
                                    Todos los PDV están activos para usar la comparativa.
                                </p>
                            </div>
                        )
                    }
                    onSortColumn={onSortColumn}
                    sortType={sortType}
                    sortColumn={sortColumn}
                    rowHeight={66}
                >
                    {/* Selección masiva */}
                    <Column width={50} fixed="left" align="center">
                        <HeaderCell style={{ padding: 0, backgroundColor: '#D2F4F6', borderRadius: '4px 0px 0px 4px' }}>
                            <Checkbox
                                inline
                                checked={allChecked}
                                indeterminate={indeterminate}
                                onChange={(_value, checked) => handleCheckAll(checked)}
                            />
                        </HeaderCell>
                        <Cell className={style['cell-content']}>
                            {(rowData) => (
                                <Checkbox
                                    inline
                                    value={rowData.id}
                                    checked={checkedKeys.includes(rowData.id)}
                                    onChange={(_value, checked) => handleCheck(rowData.id, checked)}
                                />
                            )}
                        </Cell>
                    </Column>
                    {/* Disabled or Enabled */}
                    {checkedKeys.length > 0 && (
                        <Column width={110} fixed="left" align="center">
                            <HeaderCell
                                style={{
                                    padding: 0,
                                    backgroundColor: '#D2F4F6',
                                    borderRadius: '4px 0px 0px 4px',
                                    display: 'flex',
                                    alignItems: 'center',
                                }}
                            >
                                <div
                                    className={style['action-change']}
                                    onClick={() => console.log('habiltar o deshabilitar')}
                                >
                                    <img src="/assets/images/cambiar.svg" /> {`Habilitar (${checkedKeys.length})`}
                                </div>
                            </HeaderCell>
                            <Cell>{() => null}</Cell>
                        </Column>
                    )}

                    {/* Columnas dinámicas */}

                    {columns
                        .filter((col) => visibleKeys.includes(col.key))
                        .map((col) => (
                            <Column
                                key={col.key}
                                align="center"
                                sortable={checkedKeys.length === 0}
                                minWidth={col.width}
                                flexGrow={1}
                            >
                                <HeaderCell
                                    style={{
                                        backgroundColor: '#D2F4F6',
                                        color: 'var(--Neutral-800, #40435B)',
                                        fontFeatureSettings: "'liga' off, 'clig' off",
                                        fontFamily: '"Source Sans Pro"',
                                        fontSize: '14px',
                                        fontStyle: 'normal',
                                        fontWeight: 600,
                                        lineHeight: '18px',
                                    }}
                                >
                                    {checkedKeys.length > 0 ? '' : col.label}
                                </HeaderCell>
                                {col.key === 'droguerias' ? (
                                    <Cell className={style['cell-content']}>
                                        {(rowData) => {
                                            const max = window.matchMedia('(max-width: 950px)').matches ? 2 : 4;
                                            return <ExAvatarTablePosAdmin droguerias={rowData?.droguerias} max={max} />;
                                        }}
                                    </Cell>
                                ) : (
                                    <Cell dataKey={col.key} className={style['cell-content']} />
                                )}
                            </Column>
                        ))}

                    {/* Selector de columnas visibles */}
                    {checkedKeys.length > 0 ? (
                        ''
                    ) : (
                        <Column width={112} fixed="right" align="center">
                            <HeaderCell
                                className={style['header-cell']}
                                style={{ padding: 0, backgroundColor: '#D2F4F6', borderRadius: '0px 4px 4px 0px' }}
                            >
                                <CheckPicker
                                    data={columns.map((c) => ({ label: c.label, value: c.key }))}
                                    value={visibleKeys}
                                    onChange={setVisibleKeys}
                                    placeholder="Seleccioné"
                                    style={{ width: '92px' }}
                                    cleanable={false}
                                    countable={false}
                                    className={style['header-selector']}
                                    placement="auto"
                                />
                            </HeaderCell>
                            <Cell>
                                {() => (
                                    <div onClick={() => console.log('copy')} className={style['content-copy']}>
                                        <img src="/assets/images/content_copy.svg" />
                                    </div>
                                )}
                            </Cell>
                        </Column>
                    )}
                </Table>
            </Panel>
            <div className={style['wrapper-pagination']}>
                <PaginationList
                    total={total}
                    activePage={activePage}
                    limit={limit}
                    isLoading={paginationLoading}
                    onChangePage={onChangePage}
                    onChangeLimit={onChangeLimit}
                    pages={pages}
                />
            </div>
        </>
    );
};

export default TableBackoffice;
